import { useQuery } from '@tanstack/react-query';
import type { FeatureState } from '../core/featureUtils';

export const featureKeys = {
  all: ['features'] as const,
  byToken: (tokenIdentifier: string | null) =>
    [...featureKeys.all, tokenIdentifier] as const,
};

/** Cache time matching backend's 15-minute sliding expiration */
const FEATURE_STALE_TIME = 15 * 60 * 1000; // 15 minutes

export interface UseFeaturesQueryOptions {
  apiClient: { get: <T>(url: string) => Promise<{ data: T }> };
  enabled?: boolean;
  /** Token identifier to key the query - when this changes, features are refetched */
  tokenIdentifier?: string | null;
}

export const useFeaturesQuery = (options: UseFeaturesQueryOptions) => {
  const { apiClient, enabled = true, tokenIdentifier = null } = options;

  return useQuery<FeatureState>({
    queryKey: featureKeys.byToken(tokenIdentifier),
    queryFn: async () => {
      const response = await apiClient.get<FeatureState>('/api/v1/features');
      return response.data;
    },
    staleTime: FEATURE_STALE_TIME,
    refetchInterval: FEATURE_STALE_TIME,
    enabled,
  });
};

export { FEATURE_STALE_TIME };
